const React = require("react")
// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {

    if(prevLocation && (location.pathname !== prevLocation.pathname)){
        window.dataLayer && window.dataLayer.push({'event':'dealermasters-quick-load'});
    }

        if (typeof window !== 'undefined') {
            window.Mitsubishi = {
                ...(window.Mitsubishi || {}),
                ready: false,
                pageId: `${location.pathname}${location.search}`
            };
        }
}
